import { gql } from '@apollo/client';
import { CartInfoShared } from '../fragments';

export default gql`
  query carts(
    $accountId: ID
    $states: [String!]
    $createdAtStart: String
    $createdAtEnd: String
    $limit: Int
    $offset: Int
  ) {
    carts(
      accountId: $accountId
      states: $states
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      limit: $limit
      offset: $offset
    ) {
      ...CartInfoShared
    }
  }
  ${CartInfoShared}
`;
